const imports = require("../../../../lib");
module.exports = imports.stronachgroup.first.racehorse360;

const grpc = {};
grpc.web = require("grpc-web");

module.exports.RegionServiceSimpleClient = function RegionServiceSimpleClient(
  hostname,
  credentials,
  options
) {
  if (!options) options = {};
  options["format"] = "text";

  this.client_ = new grpc.web.GrpcWebClientBase(options);
  this.hostname_ = hostname;
  this.credentials_ = credentials;
  this.options_ = options;

  this.pullRegionPreferredConditions =
    this.pullRegionPreferredConditions.bind(this);
};
const methodInfo_RegionService_PullRegionPreferredConditions =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.RegionService/PullRegionPreferredConditions",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.PullRegionPreferredConditionsRequest,
    imports.stronachgroup.first.racehorse360.PullRegionPreferredConditionsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.PullRegionPreferredConditionsResponse.decode
  );
module.exports.RegionServiceSimpleClient.prototype.pullRegionPreferredConditions =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.PullRegionPreferredConditionsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.RegionService/PullRegionPreferredConditions",
      message,
      metadata || {},
      methodInfo_RegionService_PullRegionPreferredConditions
    );
  };
